<template>
    <div>
      <header class="bg-gray-800 text-white p-4 flex justify-between items-center">
        <h1 class="text-xl font-bold">RideTrack</h1>
        <button @click="logout" class="bg-red-500 px-3 py-1 rounded">Logout</button>
      </header>
  
      <!-- Sidebar or Menu -->
      <nav class="bg-gray-200 p-4">
        <ul>
          <li>
            <router-link 
              to="/dashboard" 
              :class="linkClass('/dashboard')" 
              class="block py-2 px-4 rounded hover:bg-gray-400"
            >
              Dashboard
            </router-link>
          </li>
          <li>
            <router-link 
              to="/my-rides" 
              :class="linkClass('/my-rides')" 
              class="block py-2 px-4 rounded hover:bg-gray-400"
            >
              My Rides
            </router-link>
          </li>
          <li>
            <router-link 
              to="/settings" 
              :class="linkClass('/settings')" 
              class="block py-2 px-4 rounded hover:bg-gray-400"
            >
              Settings
            </router-link>
          </li>
          <!-- Add more menu items as needed -->
        </ul>
      </nav>
  
      <!-- Main content area -->
      <main class="p-4">
        <router-view />
      </main>
    </div>
  </template>
  
  <script setup>
  import { useRouter, useRoute } from 'vue-router';
  
  const router = useRouter();
  const route = useRoute();
  
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('otpMobile');
    router.push('/login');
  };
  
  // Function to dynamically set the class based on the current route
  const linkClass = (path) => {
    // Check if the current route matches the menu link's path
    if (route.path === path) {
      return 'bg-red-600 text-white'; // Apply red color when active
    }
    return 'text-gray-800 hover:text-red-600'; // Default color for inactive links with hover effect
  };
  </script>
  
  <style scoped>
  body {
    margin: 0;
    font-family: Arial, sans-serif;
  }
  
  nav ul {
    list-style-type: none;
    padding: 0;
  }
  .bg-red-600{
    color: red;
  }
  
  nav li {
    margin: 10px 0;
  }
  </style>
  